import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Link,
  Flex,
} from "@chakra-ui/react";
import React, { useState } from "react";
import UserIcon from "./icon/svgs/user-icon";

type LinkProps = {
  to: string;
  title: string;
  isExternal?: boolean;
};
type DropdownProps = {
  title?: string;
  links?: LinkProps[];
  my?: number | string;
  p?: number | string;
  w?: number | string;
  mt?: number | string;
  position?:
    | "fixed"
    | "-moz-initial"
    | "inherit"
    | "initial"
    | "revert"
    | "unset"
    | "-webkit-sticky"
    | "absolute"
    | "relative"
    | "static"
    | "sticky"
    | undefined;
  top?: number | string;
  isAdminUser?: boolean;
  logOut?: () => void;
};
const UserMenu = ({
  mt,
  position,
  top,
  logOut,
  isAdminUser,
  ...props
}: DropdownProps) => {
  const [open, setOpen] = useState(false);
  return (
    <Menu isOpen={open}>
      <MenuButton
        {...props}
        fontSize="16px"
        onClick={() => setOpen(!open)}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <Flex justify="space-between" align="center">
          <UserIcon /> {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </Flex>
      </MenuButton>
      <MenuList
        bg="#ffffff"
        p={5}
        fontSize={16}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        color="#000000"
        mt={mt}
        position={position || "initial"}
        top={top || "initial"}
      >
        {isAdminUser ? (
          <MenuItem as={Link} href="/dashboard" pl={0} my={5}>
            Admin Dashboard
          </MenuItem>
        ) : (
          // This is a poor implementation for routing to onboarding the incoming routing
          // PR should alleviate some of this poor navigation logic
          // https://github.com/byblackppl/byblack-cert-app/pull/71
          <MenuItem as={Link} href="/login" pl={0} my={5}>
            Go To Application
          </MenuItem>
        )}
        <MenuItem
          as={Link}
          href="/logout"
          pl={0}
          my={5}
          onClick={() => {
            if (logOut) {
              logOut();
            }
          }}
        >
          Log Out
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default UserMenu;
